const state = {
  installPrompt: null,
  isInstalled: false,
  browserSupportsInstall: false
};

const getters = {
  getInstallPrompt: state => state.installPrompt,
  canInstall: state => (state.browserSupportsInstall && !state.isInstalled),
  isInstalled: state => state.isInstalled,
  isFirefox: () => navigator.userAgent.includes('Firefox'),
  isEdge: () => navigator.userAgent.includes('Edg'),
  isChrome: () => navigator.userAgent.includes('Chrome') && !navigator.userAgent.includes('Edg')
};

const mutations = {
  SET_INSTALL_PROMPT(state, event) {
    state.installPrompt = event;
  },
  CLEAR_INSTALL_PROMPT(state) {
    state.installPrompt = null;
  },
  SET_INSTALLED(state, value) {
    state.isInstalled = value;
  },
  SET_BROWSER_SUPPORTS_INSTALL(state, value) {
    state.browserSupportsInstall = value;
  }
};

const actions = {
  // Save the install prompt event
  saveInstallPrompt({ commit }, event) {
    commit('SET_INSTALL_PROMPT', event);
    commit('SET_BROWSER_SUPPORTS_INSTALL', true);
  },
  
  // Show the install prompt
  async showInstallPrompt({ state, commit, getters }) {
    // For Chrome and chromium-based browsers that support beforeinstallprompt
    if (state.installPrompt) {
      try {
        // Show the prompt
        await state.installPrompt.prompt();
        
        // Wait for the user to respond to the prompt
        const choiceResult = await state.installPrompt.userChoice;
        
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
          commit('SET_INSTALLED', true);
        } else {
          console.log('User dismissed the install prompt');
        }
        
        // Clear the saved prompt
        commit('CLEAR_INSTALL_PROMPT');
      } catch (error) {
        console.error('Error showing install prompt:', error);
      }
    } 
    // For Firefox
    else if (getters.isFirefox) {
      // Firefox requires user to install manually via the menu
      alert('To install this app in Firefox:\n\n1. Click the three dots (≡) in the address bar\n2. Select "Install RightBuy.me"');
    } 
    // For Edge
    else if (getters.isEdge) {
      // Microsoft Edge installation instructions
      alert('To install this app in Edge:\n\n1. Click the three dots (⋯) menu in the top-right\n2. Look for "Apps" and then "Install RightBuy.me"');
    }
    // Generic instructions for other browsers
    else {
      alert('To install this app:\n\nCheck your browser menu for an "Install" or "Add to Home Screen" option.');
    }
  },
  
  // Check if the app is already installed (using display-mode)
  checkInstallation({ commit, dispatch }) {
    // Check if app is in standalone mode (installed)
    if (window.matchMedia('(display-mode: standalone)').matches || 
        window.navigator.standalone === true) {
      commit('SET_INSTALLED', true);
    } else {
      commit('SET_INSTALLED', false);
    }
    
    // Add listener for app installation
    window.addEventListener('appinstalled', () => {
      commit('SET_INSTALLED', true);
      commit('CLEAR_INSTALL_PROMPT');
    });

    // For browsers that don't support beforeinstallprompt but can install PWAs
    dispatch('checkBrowserInstallCapability');
  },

  // Check if the browser supports PWA installation even without beforeinstallprompt
  checkBrowserInstallCapability({ commit, getters }) {
    // If this is a mobile device or tablet, we can almost certainly install
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // Firefox and Edge both support PWA but don't always fire beforeinstallprompt
    if (isMobile || getters.isFirefox || getters.isEdge) {
      commit('SET_BROWSER_SUPPORTS_INSTALL', true);
    }

    // Check manifest for installability
    fetch('/manifest.json')
      .then(response => {
        if (response.ok) {
          // If manifest exists, most modern browsers can install
          commit('SET_BROWSER_SUPPORTS_INSTALL', true);
        }
      })
      .catch(error => {
        console.error('Error checking manifest:', error);
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}; 